var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m14.067 17.487 3.907-14.973a.77.77 0 0 0-1.1-.877L1.893 9.45c-.523.27-.554 1.008-.062 1.33l11.075 7.169a.77.77 0 0 0 1.16-.454z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m9.952 16.21-3.076 2.308v-4.615M6.976 13.85l7.59-8.406"
})));
export default SvgSendMessage;